'use client';

import { NewsroomBodySection } from './_components/NewsroomBodySection';
import { NewsroomHero } from './_components/NewsroomHero';

const Content = () => {
  return (
    <>
      <NewsroomHero />
      <NewsroomBodySection />
    </>
  );
};

export default Content;
